import { useNavigate, useParams } from "react-router-dom";
import { ConteudoConfirmAgendaNotific } from "../../../interfaces/props/ConteudoConfirmAgendaNotific";
import parse from 'html-react-parser';
import { atualizarIndLidoComunica, excluirComunicado, getConteudoConfirmAgendaNotific } from "../../../services/ComunicadoService";
import { useEffect, useState } from "react";
import LoadingApp from "../../../components/LoadingApp";
import ButtonAccessibility from "../../../components/Accessibility/ButtonAccessibility";
import './styles.css';
import VoltarButton from "../../../components/Accessibility/VoltarButton";
import ModalActionResponsive from "../../../components/ModalActionResponsive";
import { cancelarAgendamento, confirmarAgendamento } from "../../../services/AgendamentoService";
import ModalFeedBack from "../../../components/ModalFeedBack";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLaptopMedical } from "@fortawesome/pro-duotone-svg-icons";
import ModalAgendamentoTerminado from "./ModalAgendamentoTerminado";
import { useNotification } from "../../../Store/contexts/NotificationContext";
import { useAccessibility } from "../../../Store/contexts/AccessibilityContext";
import DefaultButton from "../../../components/Accessibility/DefaultButton";

const NotificationConfirmarConsulta = () => {
    const navigate = useNavigate();
    const { contrastMode } = useAccessibility();
    const { idAgenda, tipoNotificacao, idComunic } = useParams();
    const { updateUnreadNotificationsNumber } = useNotification();
    const [loading, setLoading] = useState<boolean>(false);
    const [conteudoNotification, setConteudoNotification] = useState<ConteudoConfirmAgendaNotific | null>(null);
    const [textModal, setTextModal] = useState<string>('');
    const [showModal, setShowModal] = useState<boolean>(false);
    const [actionType, setActionType] = useState<'confirmar' | 'cancelar'>('cancelar');
    const [showAgendamentoTerminado, setShowAgendamentoTerminado] = useState<boolean>(false)
    const [modalFeedback, setModalFeedback] = useState<null | {
        icon?: "none" | "warning" | "error" | "success",
        title?: string,
        textButton?: string,
        subTitle?: string,
        closeAction: () => void,
        showButtonModal: boolean,
        buttonAction?: () => void
    }>(null);

    const handleGetConfirmarConsulta = async () => {
        if (tipoNotificacao && idAgenda) {
            setLoading(true);
            getConteudoConfirmAgendaNotific(Number(idAgenda), tipoNotificacao)
                .then(response => {
                    setConteudoNotification(response)
                    if (response?.excluirNotificacao) {
                        setShowAgendamentoTerminado(true)
                    }
                })
                .finally(() => setLoading(false));
        }

        await atualizarIndLidoComunica(`${idComunic}`, 'S');

        await updateUnreadNotificationsNumber();
    };

    const handleAction = () => {
        setLoading(true);
        if (actionType === 'cancelar' && idComunic && conteudoNotification?.item?.idInstal && idAgenda) {
            cancelarAgendamento(conteudoNotification.item.idInstal.toString(), idAgenda)
                .then((response) => {
                    if (response?.status !== 200) {
                        setModalFeedback({
                            icon: 'error',
                            title: 'Erro',
                            subTitle: 'Ocorreu um erro, tente novamente em alguns instantes.',
                            textButton: 'Fechar',
                            closeAction: () => setModalFeedback(null),
                            showButtonModal: true
                        });
                        return;
                    }
                    excluirComunicado(idComunic, 'S');
                    setModalFeedback({
                        icon: 'success',
                        title: 'Agendamento cancelado com sucesso!',
                        textButton: 'Fechar',
                        closeAction: () => navigate('/notificacoes/notificacao'),
                        showButtonModal: true
                    });
                })
                .finally(() => setLoading(false));
        } else if (actionType === 'confirmar' && conteudoNotification?.item?.idInstal && idAgenda && idComunic) {
            confirmarAgendamento(Number(conteudoNotification.item.idInstal), Number(idAgenda), 'canal-pf')
                .then((response) => {
                    if (response?.status !== 200) {
                        setModalFeedback({
                            icon: 'error',
                            title: 'Erro',
                            subTitle: 'Ocorreu um erro, tente novamente em alguns instantes.',
                            textButton: 'Fechar',
                            closeAction: () => setModalFeedback(null),
                            showButtonModal: true
                        });
                        return;
                    }
                    excluirComunicado(idComunic, 'S');
                    setModalFeedback({
                        icon: 'success',
                        title: 'Agendamento confirmado com sucesso!',
                        textButton: 'IR PARA MEUS AGENDAMENTOS',
                        closeAction: () => navigate('/saudeOnline/meusAgendamentos'),
                        showButtonModal: true
                    });
                })
                .finally(() => setLoading(false));
        }
        setShowModal(false);
    };

    const handleShowModal = (type: 'confirmar' | 'cancelar') => {
        setActionType(type);
        setTextModal(type === 'confirmar'
            ? 'Deseja realmente confirmar este agendamento?'
            : 'Deseja realmente cancelar este agendamento?');
        setShowModal(true);
    };

    useEffect(() => {
        handleGetConfirmarConsulta();
    }, []);


    return (
        <div className='notification-confirmar-consulta'>
            <div className="statement-icon-holder">
                <FontAwesomeIcon icon={faLaptopMedical} size='2xl' />
            </div>
            <h1 className='title' style={{ color: contrastMode ? '#fff' : '' }}>Telemedicina: confirme agora sua consulta</h1>
            {!conteudoNotification?.excluirNotificacao &&
                <>
                    <div className='description' style={{ color: contrastMode ? '#fff' : '' }}>{parse(conteudoNotification?.dadosAgenda ?? '')}</div>
                    <div className="container-buttons">
                        {conteudoNotification?.botaoConfirmar && <DefaultButton
                            onClick={() => handleShowModal('confirmar')}
                            variant="contained"
                            text="Confirmar agendamento" />
                        }
                        {conteudoNotification?.botaoCancelar &&
                            <DefaultButton
                                onClick={() => handleShowModal('cancelar')}
                                variant="contained"
                                sx={{
                                    background: '#d32f2f',
                                    "&:hover": {
                                        background: "#8F1131",
                                    },
                                }}
                                color="error"
                                text="Cancelar agendamento" />
                        }
                    </div>
                    {conteudoNotification?.textos?.map((texto, index) => (
                        <div key={index} className='description' style={{ color: contrastMode ? '#fff' : '' }}>
                            {parse(texto)}
                        </div>
                    ))}
                    <a href={conteudoNotification?.link} style={{ color: contrastMode ? '#fff' : '' }} target="_blank" rel="noreferrer" className="link-confirmar-consulta">
                        {conteudoNotification?.link}
                    </a>
                    <VoltarButton onClick={() => navigate(-1)} />
                    <ModalActionResponsive
                        showModal={showModal}
                        title="Atenção"
                        icon="warning"
                        subTitle={textModal}
                        textContainedButton={actionType === 'cancelar' ? 'Cancelar' : 'Confirmar'}
                        textOutlinedButton="Voltar"
                        handleContainedButton={handleAction}
                        handleOutlinedButton={() => setShowModal(false)}
                        handleShowModal={() => setShowModal(false)}
                        colorContainedButton={actionType === 'cancelar' ? 'error' : 'success'}
                    />
                    {modalFeedback && (
                        <ModalFeedBack
                            showModal={!!modalFeedback}
                            icon={modalFeedback?.icon as 'success' | 'error'}
                            title={modalFeedback?.title ?? ''}
                            subTitle={modalFeedback.subTitle ?? ''}
                            textButton={modalFeedback.textButton ?? ''}
                            showButtonModal={modalFeedback.showButtonModal}
                            handleButtonModal={modalFeedback.buttonAction || modalFeedback.closeAction}
                            handleShowModal={modalFeedback.closeAction}
                            classNameModal="modal-custom"
                        />
                    )}
                </>
            }
            <ModalAgendamentoTerminado
                showModal={showAgendamentoTerminado}
                subTitle={conteudoNotification?.textos[0] ?? ''}
            />
            <LoadingApp showLoading={loading} />
        </div>
    );
};

export default NotificationConfirmarConsulta;
